import { ENDPOINTS } from "../../constants/endpoints.constant";
import Loader from "../../components/Loader";
import { useAPI } from "../../hooks/useAPI";
import { ROUTES } from "../../constants/routes.constant";
import { getCall } from "../../constants/apicalls.constant";
import { useDispatch, useSelector } from "react-redux";
import { EventData } from "../../models/event";
import { useNavigate } from "react-router";
import { Radio, Flex, Button, Row, Col, Badge, Empty, message } from "antd";
import styles from "./events.module.scss";
import { setSelectedEventList } from "../../store/slices/event.slice";
import { IconPlus, IconReportMoney } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import { RootState } from "../../store/store";
import { setNewUser } from "../../store/slices/user.slice";
import { WorkspaceCheckerHide } from "../../components/WorkspaceChecker";
import EventCard from "../../components/eventCard";
import Container from "../../components/container";
import { setEditEvent } from "../../store/slices/eventedit.slice";
import PendingKyc from "../kyc-verification/pendingKyc";

const Events = () => {
  const navigate = useNavigate();

  const [filter, setFilter] = useState<string>("upcoming");
  const user = useSelector((state: RootState) => state.user);
  const workspace = useSelector((state: RootState) => state.workspace);
  const dispatch = useDispatch();

  const { response, loading, error } = useAPI<{
    status: boolean;
    message: string;
    data: {
      new_user: boolean;
      data: EventData[];
      event_count: {
        upcoming: number;
        past: number;
        archived: number;
      };
    };
  }>(
    ENDPOINTS.event,
    true,
    [filter, "draft", workspace],
    getCall({
      filter: { [filter]: { $eq: "" } },
    }),
  );

  const navigateToSetupStep = (data: EventData) => {
    const steps = data?.steps_info || [];
    if (!steps.includes("basic_info"))
      navigate(ROUTES.EDIT_EVENT.path.replace(":id", data.id!));
    else if (!steps.includes("event_details"))
      navigate(ROUTES.ADD_EVENT_DETAILS.path.replace(":id", data.id!));
    else if (!steps.includes("ticket_config"))
      navigate(ROUTES.ADD_TICKET.path.replace(":id", data.id!));
    else if (!steps.includes("custom_form"))
      navigate(ROUTES.ADD_EVENT_CUSTOM_FORM.path.replace(":id", data.id!));
    else if (data.status === "draft" || data.status === "rejected") {
      navigate(ROUTES.REVIEW_AND_PUBLISH.path.replace(":id", data.id!));
    } else {
      navigate(ROUTES.EDIT_EVENT.path.replace(":id", data.id!));
    }
  };

  const redirection = (data: EventData) => {
    if (
      data?.status === "published" ||
      data?.status === "scheduled" ||
      data?.status === "completed" ||
      data?.status === "archived"
    ) {
      navigate(
        ROUTES[
          data.permissions?.event_access?.permissions?.[0].toUpperCase() as keyof typeof ROUTES
        ].path.replace(":id", data.id!),
      );
      return;
    }

    navigateToSetupStep(data);
  };
  useEffect(() => {
    if (response?.data) {
      dispatch(setNewUser(response.data.new_user));
    }
    dispatch(
      setSelectedEventList({
        id: "",
        name: "",
        description: "",
        is_custom_form: false,
        form_config: [],
        show_available_tickets: false,
        is_verified: false,
        age_group: "",
        language: "",
        cover_image: "",
        category_id: "",
        visiblity: "public",
        feature_images: [],
        banner_image: "",
        video_url: "",
        dynamic_qr: false,
        permissions: { event_access: { permissions: [] } },
      }),
    );
    dispatch(setEditEvent({ editEvent: false }));
  }, [response, dispatch]);

  if (error) {
    message.error("Something went wrong....");
    return null;
  }

  const showAddEvent = filter !== "past" && filter !== "archived";

  return (
    <div>
      <PendingKyc user={user} />
      {loading ? (
        <Loader />
      ) : (
        <div className="py-[24px]">
          <Container
            className={
              response?.data?.data?.length === 0 &&
              filter !== "past" &&
              filter !== "archived"
                ? "px-[0!important]"
                : ""
            }
          >
            <Flex
              gap={
                response?.data?.data?.length === 0 &&
                filter !== "past" &&
                filter !== "archived"
                  ? 0
                  : 20
              }
              vertical
            >
              <Flex justify="space-between" align="center" gap={12} wrap="wrap">
                <div>
                  <h2 className="ds-page-header-title ff-title !text-xl">
                    My Events
                  </h2>
                  <p className="ds-page-header-desc">
                    Manage and monitor your events
                  </p>
                </div>
                <Flex gap={12} align="center" wrap="wrap">
                  <Radio.Group
                    className={styles.eventStatusSelector}
                    buttonStyle="solid"
                    value={filter}
                    onChange={(e) => {
                      const v = e.target.value;
                      setFilter(v);
                    }}
                  >
                    <Radio.Button value="upcoming">
                      Active{" "}
                      {response?.data?.event_count?.upcoming &&
                      response?.data?.event_count?.upcoming > 0 ? (
                        <Badge>{response?.data?.event_count?.upcoming}</Badge>
                      ) : null}
                    </Radio.Button>
                    <Radio.Button value="past">
                      Past
                      {response?.data?.event_count?.past &&
                      response?.data?.event_count?.past > 0 ? (
                        <Badge>{response?.data?.event_count?.past}</Badge>
                      ) : null}
                    </Radio.Button>
                    <Radio.Button value="archived">
                      Archived
                      {response?.data?.event_count?.archived &&
                      response?.data?.event_count?.archived > 0 ? (
                        <Badge>{response?.data?.event_count?.archived}</Badge>
                      ) : null}
                    </Radio.Button>
                  </Radio.Group>
                  <Button
                    icon={<IconReportMoney size={16} />}
                    onClick={() => navigate(ROUTES.WORKSPACE_PAYOUTS.path)}
                  >
                    Payout Report
                  </Button>
                </Flex>
              </Flex>

              {response?.data?.data?.length ? (
                <>
                  <Row gutter={[24, 24]} className="m-0">
                    {showAddEvent && (
                      <Col xs={24} sm={12} md={8} lg={6}>
                        <WorkspaceCheckerHide>
                          <Button
                            type="dashed"
                            className="!w-full !p-[52px] !rounded-[16px] !flex"
                            style={{
                              aspectRatio: "282/262",
                              height: "100%",
                              width: "100%",
                            }}
                            onClick={() => navigate(ROUTES.ADD_EVENT.path)}
                            icon={<IconPlus size={14} />}
                          >
                            Add Event
                          </Button>
                        </WorkspaceCheckerHide>
                      </Col>
                    )}

                    {[...(response?.data?.data || [])].map(
                      (data: EventData) => (
                        <Col xs={24} sm={12} md={8} lg={6} key={data?.id}>
                          <EventCard
                            eventD={data}
                            fn={() => {
                              dispatch(setSelectedEventList(data));
                              redirection(data);
                            }}
                          />
                        </Col>
                      ),
                    )}
                  </Row>
                  {/* </div> */}
                </>
              ) : (
                <>
                  {filter === "past" ? (
                    <>
                      <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description="No past events yet, they will appear when everyone goes back home"
                      />
                    </>
                  ) : filter === "archived" ? (
                    <>
                      <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description="No archived events yet, they will appear when you cancel the plan for all at once"
                      />
                    </>
                  ) : (
                    <WorkspaceCheckerHide>
                      <div className={styles.spotlightScene}>
                        <div className={styles.spotlight}></div>
                        <div className="ff-title text-[32px] text-center text-black font-bold leading-[1.2]">
                          The stage is set, but the spotlight is empty.
                        </div>
                        <Button
                          type="dashed"
                          className={`${styles.addEventButton}  ${styles.firstEvent}`}
                          onClick={() => navigate(ROUTES.ADD_EVENT.path)}
                          icon={<IconPlus size={24} />}
                        >
                          Let's create your first event
                        </Button>
                        <div className={styles.floor}></div>
                      </div>
                    </WorkspaceCheckerHide>
                  )}
                </>
              )}
            </Flex>
          </Container>
        </div>
      )}
    </div>
  );
};

export default Events;
